<template>
  <f7-card class="comment-input-root">
    <f7-list>
      <f7-list-input type="textarea"
                     :placeholder="$t('placeholder.enterComment')"
                     :value="value"
                     @input="content = $event.target.value"
                     resizable
                     class="input-no-line"
                     @keydown.native.enter.exact.prevent="submit"
                     @keydown.native.shift.enter.exact="() => {this.content += '\n'}"
      >
        <transition slot="content-end" name="arrow-slide">
          <div v-if="value" class="comment-button">
            <f7-link @click="submit"
                     icon-ios="f7:arrow_right"
                     icon-md="f7:arrow_right"
            >
            </f7-link>
          </div>
        </transition>
      </f7-list-input>
    </f7-list>
  </f7-card>
</template>

<script>
  export default {
    name: "CommentInput",
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        content: this.value,
      }
    },
    model: {
      prop: 'value',
      event: 'input',
    },
    methods: {
      submit () {
        if (this.content.trim()) {
          this.$emit('comment')
        }
      },
    },
    watch: {
      content () {
        this.$emit('input', this.content)
      },
      value () {
        this.content = this.value
      }
    }
  }
</script>

<style lang="scss" scoped>
  .comment-input-root {
    overflow: hidden;
  }
  .comment-button {
    padding-right: 1em;
  }

  .arrow-slide-enter-active {
    transition: all 0.5s, transform 0.2s;
  }

  .arrow-slide-leave-active {
    transition: all 0.5s, opacity 0.2s;
  }

  .arrow-slide-enter, .arrow-slide-leave-to {
    opacity: 0;
  }

  .arrow-slide-enter {
    transform: translateX(-100%);
  }

  .arrow-slide-leave-to {
    transform: translateX(100%);
  }

  .arrow-slide-leave, .arrow-slide-enter-to {
    opacity: 1;
    transform: translateX(0);
  }

</style>

<style lang="scss">
  // scoped seems to be quite effective at preventing rules from affecting things not defined by this component
  // not just classes.
  .input-no-line .item-input-wrap:after {
    display: none !important;
  }

  .comment-input-root textarea {
    line-height: 1 !important;
  }
</style>
